import { fetchApi } from '@coconut/services/apis/utils';

export const cancelQuestion = ({ lang, userId, questionId }) =>
  fetchApi(
    `api/v2/students/${userId}/questions/${questionId}/cancel`,
    'PATCH',
    {
      data: {
        lang,
      },
    }
  ).then((res) => res);



// WEBPACK FOOTER //
// ./src/services/apis/cancelQuestion.js